import * as React from 'react'
import { Link } from 'react-router-dom'

import { Select, SelectOption } from '../../../main/components/select'
import { useChartTypes } from './use-chart-type'

const SELECT_LIST_PROPS = { rounding: 'none' } as const
const buttonStyle: React.CSSProperties = { height: 28, border: '1px solid #f0f1f5', color: '#000' }

const isNativeMobileSelect = true // explicitly enable native select for mobile devices

export function ChartTypesSelect({ isPremium }: { isPremium: boolean }) {
  const { chartTypes, getCurrentType } = useChartTypes({ isPremium })
  const currentType = getCurrentType()

  return (
    <Select
      data-testid="chart-type-select"
      aria-label="Chart type"
      value={currentType}
      items={chartTypes}
      className="w-24"
      style={buttonStyle}
      rounding="none"
      leftContent={chartTypes.find((item) => item.value === currentType)?.iconName}
      rightContent="caretDown"
      listProps={SELECT_LIST_PROPS}
      hasPopoverButtonWidthLimit={false}
      isNativeMobileSelect={isNativeMobileSelect}
    >
      {chartTypes.map((item) => (
        <SelectOption
          as={item.href ? Link : undefined}
          to={item.href}
          reloadDocument={item.href ? !FinvizSettings.hasUserPremium : undefined}
          data-testid={`chart-type-select-option-${item.value}`}
          key={item.value}
          leftContent={item.iconName}
          rounding="none"
        >
          {item.label}
        </SelectOption>
      ))}
    </Select>
  )
}
